import { IoMdSpeedometer } from "react-icons/io";
import {
  COMPANY_PERFORMANCE,
  COMPANY_PERFORMANCE_TEXT,
} from "../../constants/translations";
import performanceImage from "../../asset/images/aboutUs/performance.png";
const CompanyPerformance = () => {
  return (
    <section className="company-performance">
      <div className="performance-img-wrapper">
        <img
          src={performanceImage}
          alt="Company Performance"
          width={640}
          height={360}
        />
      </div>
      <div className="performance-texts">
        <div className="p-content-controller">
          <IoMdSpeedometer className="performance-icon" />
          <h3 className="performance-title">{COMPANY_PERFORMANCE}</h3>
          <p className="performance-text">{COMPANY_PERFORMANCE_TEXT}</p>
        </div>
      </div>
    </section>
  );
};

export default CompanyPerformance;
